import React from 'react';

const HeadphoneIcon = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" className="size-8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="28.6631" y="55.8649" width="12.6742" height="8.14773" rx="4.07386" fill="currentColor" />
    <path
      d="M53.1593 44.5489C53.0143 45.7453 53.3874 48.1381 56.0405 48.1381C59.3569 48.1381 65.822 47.0046 65.822 38.0203V35.1234C65.724 32.1425 63.79 26.1809 56.8377 26.1809C56.171 19.4497 50.9539 5.98743 35.4186 5.98743C15.9995 5.98743 13.1337 25.1638 13.1337 26.1809C10.1481 26.4546 4.17676 28.5231 4.17676 34.6075V38.7822C4.29853 41.8898 6.19528 48.105 12.8081 48.105C14.213 48.2812 17.0227 47.9892 17.0227 45.4118V27.3317C17.5698 21.4973 22.0149 9.82854 35.4186 9.82854C48.8223 9.82854 52.8306 22.0102 53.1593 28.1011V44.5489Z"
      fill="currentColor"
    />
    <path
      d="M12.3677 50.2887H14.6019C15.2629 53.2342 18.6034 59.1251 26.6766 59.1251V61.3091C22.9719 61.6098 14.9234 59.8268 12.3677 50.2887Z"
      fill="currentColor"
    />
  </svg>
);

export default HeadphoneIcon;
